import React, { useEffect, useLayoutEffect, useState } from 'react';
import OTP from '../otp';
import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import Consent from 'views/pages/dashboard/CompanyProfile/IntegrateDiolog/DiologMenu/EmailIntegration.js/Consent';

const ConsentOtp = (props) => {
    const navigate = useNavigate();
    let userData = localStorage.getItem('diologUserData');
    const token = localStorage.getItem('diologAuthToken');

    if (userData) {
        userData = JSON.parse(userData);
    }

    const { id, email } = useParams();
    const [step, setStep] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const companyId = id || userData?.companyId;
    const userEmail = email || userData?.email;

    useEffect(() => {
        if (!token) {
            navigate('/', { replace: true });
        }
    }, [token]);

    return (
        <main className={isLoading && 'ext-loading'}>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" width="100vw">
                <Box className="ext-container">
                    {step === 0 && (
                        <OTP
                            goBack={false}
                            isConsentOtp={!!id}
                            email={userEmail}
                            setActiveStep={() => setStep(2)}
                            setLoading={setIsLoading}
                        />
                    )}
                    {step === 2 && (
                        <Consent
                            setSignIn={() => setStep(0)}
                            data={{ email: userEmail, companyId, userEmail: props.userEmail }}
                            callback={(value) => setIsLoading(value)}
                            isConsentOtp={!!id}
                        />
                    )}
                </Box>
            </Box>
        </main>
    );
};

export default ConsentOtp;
